module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--19.372d68da.png";